<template>
  <b-button :variant="variant">
    {{ title }}
  </b-button>
</template>

<script>
export default {
  props: {
    variant: {
      type   : String,
      default: '',
    },
    title: {
      type   : String,
      default: '',
    },
  },
}
</script>
